import { PatientCommandParams } from './PatientCommandParams';
import { Command } from './Command';
import { NCZIExtension } from '../Interfaces/ncziTypes';

export type CancelVaccinationResultParams = PatientCommandParams & {
	vaccination: {
		previousVersion: NCZIExtension;
		sensitivity: number;
		uncertaintyExpressed: boolean;
		createdAt: string;
		versionStatus: string;
		reason: string;
	};
};

export const CancelVaccinationResult = (
	params: CancelVaccinationResultParams,
): Command => {
	return {
		operation: 'StornujOckovaciZaznam',
		params,
	};
};
